import { defineSlotRecipe } from '@chakra-ui/react';
export const menuRecipe = defineSlotRecipe({
    className: 'menu',
    slots: [
        'content',
        'item',
        'itemText',
        'separator',
        'trigger',
        'indicator',
        'positioner',
        'arrow',
        'arrowTip',
        'itemGroup',
        'itemGroupLabel',
        'itemIndicator',
        'itemCommand',
        'contextTrigger',
    ],
    base: {
        content: {
            // House rule: no shadow; the hairline below sets the panel apart.
            boxShadow: 'none',
            background: '#FEFDFD',
            borderWidth: '1px',
            borderColor: 'border',
            rounded: 'xl',
            padding: '1.5',
            minWidth: '11rem',
        },
        item: {
            rounded: 'md',
            paddingInline: '2.5',
            paddingBlock: '2',
            fontSize: 'sm',
            color: 'fg',
            cursor: 'pointer',
            transitionProperty: 'background',
            transitionDuration: 'fast',
            _highlighted: {
                bg: 'softCream',
            },
        },
        itemGroupLabel: {
            paddingInline: '2.5',
            paddingBlock: '1.5',
            fontSize: 'xs',
            fontWeight: 'semibold',
            color: 'fg.muted',
            textTransform: 'uppercase',
            letterSpacing: 'wide',
        },
        separator: {
            height: '1px',
            background: 'border',
            marginBlock: '1.5',
        },
        itemCommand: {
            fontSize: 'xs',
            color: 'fg.subtle',
            letterSpacing: 'wide',
            marginInlineStart: 'auto',
            paddingInlineStart: '4',
        },
    },
});
